export const PENDING_ITEMS_TYPES = ({
  Questionnaire: 'Questionnaire',
  Custom: 'Custom',
  OverlapAssignment: 'OverlapAssignment'
} as const);
export type PendingItemKeyType = (typeof PENDING_ITEMS_TYPES)[keyof typeof PENDING_ITEMS_TYPES];